import { computed } from 'vue';
import type { UseAssetFormLayout } from '../types';
import { EAssetMaintainer, getRefId, type ILiability } from 'findef';
import { DetailCard } from 'components/detail-card';
import { toTitle } from '@/utils/string';
import { prettyNumber } from '@/utils/number/format';
import { getMaintainedText } from '@/utils/liability/maintained';

export const liabilitiesLayout = (): UseAssetFormLayout => {
  return {
    children: (state, form) => {
      const children: UseAssetFormLayout[] = [
        { render: 'hasLiabilitiesAttached', key: 'hasLiabilitiesAttached' },
      ];

      //const children: UseAssetFormLayout[] = [
      //  { render: 'hasLiabilitiesAttached', key: 'hasLiabilitiesAttached' },
      //  ...(state.hasLiabilitiesAttached
      //    ? [{ render: 'selectLiability', key: 'selectLiability' }]
      //    : [])
      //]

      if (state.hasLiabilitiesAttached) {
        children.push({
          render: 'liabilities',
          key: 'liabilities',
        });
        if (state.liabilities && Array.isArray(state.liabilities) && state.liabilities.length > 0) {
          children.push({
            key: 'liability-list',
            component: (_state, form) => {
              return (props) => {
                const state = props.state.value;

                const liabilities = computed(() => {
                  const data = state.liabilities;
                  return Array.isArray(data) ? (data as ILiability[]) : [];
                });
                const handleRemove = (liab: ILiability) => {
                  form.updateFieldValue('liabilities', (liabilities) => {
                    if (!Array.isArray(liabilities)) return [];
                    return liabilities.filter((it) => getRefId(it) !== getRefId(liab));
                  });
                };

                return (
                  <div
                    class="grid grid-cols-1 gap-4"
                  >
                    {liabilities.value.map((liab) => {
                      const providerImport = liab?.providerImport;
                      const provider =
                        providerImport &&
                        typeof providerImport !== 'string' &&
                        'provider' in (providerImport as any)
                          ? (providerImport as any).provider
                          : undefined;

                      const maintainedText =
                        getMaintainedText(liab) === EAssetMaintainer.PROVIDER
                          ? provider?.displayName || EAssetMaintainer.PROVIDER.toLocaleLowerCase()
                          : EAssetMaintainer.MANUAL.toLocaleLowerCase();

                      return (
                        <DetailCard
                          key={getRefId(liab)}
                          title={liab.name || '?'}
                          subtitle={`Debt (${liab.subtype ? toTitle(liab.subtype) : ''})`}
                          badgeText={prettyNumber(liab.amount?.value || 0, {
                            american: true,
                            maxDecimals: 2,
                            zeroIsInteger: true,
                            suffix: liab.amount?.type || '',
                          })}
                          badgeMaintained={{
                            name: provider?.name,
                            iconUrl: provider?.iconUrl,
                            title: maintainedText,
                          }}
                          onClose={() => handleRemove(liab)}
                          icon={{
                            src: async () => import('assets/img/svg/icons/receipt.svg?raw'),
                            size: '1.25rem',
                            stroke: 'none',
                            fill: 'currentColor',
                          }}
                        />
                      );
                    })}
                  </div>
                );
              };
            },
          });
        }

        if (form.props.externalData?.currentLiability?.value) {
          children.push({
            key: 'current-liability',
            component: (_state, form) => {
              return () => {
                return (
                  <div
                    class="grid grid-cols-1 gap-4"
                    style={{
                      gridTemplateColumns: '1fr',
                    }}
                  >
                    {form.props.externalData?.currentLiability?.value &&
                      (() => {
                        const liab = form.props.externalData?.currentLiability?.value as ILiability;
                        const providerImport = liab?.providerImport;
                        const provider =
                          providerImport &&
                          typeof providerImport !== 'string' &&
                          'provider' in (providerImport as any)
                            ? (providerImport as any).provider
                            : undefined;

                        const maintainedText =
                          getMaintainedText(liab) === EAssetMaintainer.PROVIDER
                            ? provider?.displayName || EAssetMaintainer.PROVIDER.toLocaleLowerCase()
                            : EAssetMaintainer.MANUAL.toLocaleLowerCase();

                        if (!liab) return <div />;
                        return (
                          <DetailCard
                            key={'MOCK'}
                            title={liab.name ?? '?'}
                            subtitle={`Debt (${liab.subtype ? toTitle(liab.subtype) : ''})`}
                            badgeText={prettyNumber(liab.amount?.value || 0, {
                              american: true,
                              maxDecimals: 2,
                              zeroIsInteger: true,
                              suffix: liab.amount?.type || '',
                            })}
                            badgeMaintained={{
                              name: provider?.name,
                              iconUrl: provider?.iconUrl,
                              title: maintainedText,
                            }}
                            icon={{
                              src: async () => import('assets/img/svg/icons/receipt.svg?raw'),
                              size: '1.25rem',
                              stroke: 'none',
                              fill: 'currentColor',
                            }}
                            closeIsDisabled={true}
                          />
                        );
                      })()}
                  </div>
                );
              };
            },
          });
        }
      }

      return children;
    },
  };
};
